/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
export const StringTable = [
  {
    "key": "sampleStrKey",
    "en": "Sample"
  },
  {
    "key": "camNotFound",
    "en": "Camera not installed at this place. Please contact the customer care"
  },
  {
    "key": "noEventsFound",
    "en": "No events found"
  },
  {
    "key": "defaultErrorMsg",
    "en": "An error occurred, please try again. Contact customer care if problem persists"
  },
  {
    "key": "noEventFields",
    "en": "Please select event fields"
  },
  {
    "key": "downloadEventsWithNoImages",
    "en": "Dowload pdf/xlsx (Event images not present)"
  },
  {
    "key": "downloadEventsWithImages",
    "en": "Save page as pdf (Event images present)"
  },
  {
    "key": "noItemsFound",
    "en": "No items to show here"
  },
  {
    "key": "permissionError",
    "en": "You may not have the required access permissions. "
  },
]


// WEBPACK FOOTER //
// ./src/StringTable.js